// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AlignCenterOutlinedSvg from "@ant-design/icons-svg/es/asn/AlignCenterOutlined";
import AntdIcon from '../components/AntdIcon';

var AlignCenterOutlined = function AlignCenterOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: AlignCenterOutlinedSvg
  }));
};

AlignCenterOutlined.displayName = 'AlignCenterOutlined';
export default React.forwardRef(AlignCenterOutlined);